import { useSiteContext, useTranslation } from '@eti/providers';
import { useMemo } from 'react';
import { Badge } from '@etg/wings';
import { duration as durationUtil } from '@eti/utils';
import { getExpirationFormat } from './utils/utils';

interface ExpirationBadgeProps {
  dataTestId: string;
  expires: number;
}

const ExpirationBadge = ({ dataTestId, expires }: ExpirationBadgeProps) => {
  const { t } = useTranslation();
  const { language } = useSiteContext();
  const expiration = useMemo(() => {
    const { badgeVariant, units } = getExpirationFormat(expires, false);
    return {
      badgeVariant,
      timeLeft: durationUtil.getDuration(expires * 1000, language.code, undefined, units, true),
    };
  }, [expires, language.code]);

  return (
    <Badge data-testid={dataTestId} variant={expiration.badgeVariant}>
      {t('ManageTrip.Cancel.Expires.TimeLeft.Text', expiration.timeLeft)}
    </Badge>
  );
};

export default ExpirationBadge;
